<div class="input-group" style="width: 100%" aria-label="Select Lease Type">
    <select name="select"
            [(ngModel)]="value"
            class="form-select form-select-sm exclude-modal-styling"
            (ngModelChange)="select($event)">
        <option value="One Time">One Time</option>
        <option value="Recurring">Recurring</option>
    </select>
</div>
